<canvas
  #canvas
  class="logrocket-disable-recording"
  (webglcontextrestored)="onWebglContextRestored()"
></canvas>
